export const backgroundMusic = [
  {
    titleKey: "fire",
    artistKey: "naturalSounds",
    url: "/fire.mp3",
    durationKey: "unknown"
  },
  {
    titleKey: "forest",
    artistKey: "naturalSounds",
    url: "/forests.mp3",
    durationKey: "unknown"
  },
  {
    titleKey: "water",
    artistKey: "naturalSounds",
    url: "/water.mp3",
    durationKey: "unknown"
  },
  {
    titleKey: "ocean",
    artistKey: "naturalSounds",
    url: "/ocean.m4a",
    durationKey: "unknown"
  },
  {
    titleKey: "faraway",
    artistKey: "ambientMusic",
    url: "/faraway.m4a",
    durationKey: "unknown"
  },
  {
    titleKey: "cafe",
    artistKey: "lightMusic",
    url: "/cafe.mp3",
    durationKey: "unknown"
  },
  {
    titleKey: "storm",
    artistKey: "naturalSounds",
    url: "/storm.m4a",
    durationKey: "unknown"
  },
  {
    titleKey: "woodenFish",
    artistKey: "meditationMusic",
    url: "/woodenFish.mp3",
    durationKey: "unknown"
  }
];